import React from 'react';

export default function PdfViewer({ pdfUrl, pdfHeight }) {
    return (
        <div>
            <iframe
                title="PDF Viewer"
                src={pdfUrl ? `${process.env.PUBLIC_URL}pdfjs/web/viewer.html?file=${pdfUrl}&locale=ja` : ""}
                style={{
                    width: '100%',
                    height: pdfHeight ? pdfHeight : '100vh',
                    border: 'none',
                }}
            ></iframe>
        </div>
    );
}
